var map = {
	"./charcoal_bold.webp": "a29d",
	"./charcoal_dark.webp": "46a4",
	"./charcoal_light.webp": "0d86",
	"./circle.webp": "fc8a",
	"./contrast_default.webp": "eb59",
	"./contrast_low_brightness.webp": "9e4c",
	"./edge_sharp.webp": "dd49",
	"./edge_soft.webp": "16e9",
	"./equalize.webp": "93e3",
	"./grayscale_high.webp": "a8a0",
	"./grayscale_light.webp": "e787",
	"./grayscale_medium.webp": "3283",
	"./invert_black.webp": "54d0",
	"./invert_blue.webp": "a0f1",
	"./invert_red.webp": "90cf",
	"./invert_yellow.webp": "d59d",
	"./normal.webp": "70da",
	"./oilpaint.webp": "a24a",
	"./paper_torn.webp": "90e6",
	"./paper_torn_light.webp": "1c2e",
	"./rounded.webp": "ea02",
	"./soft_edge.webp": "f5fc",
	"./vignette.webp": "5f13"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f3f7";